export default __webpack_public_path__ + "media/placeholder/person_placeholder-938b7a16.png";